<script>
export default {
    name: "IPDrugDispensingList",

    data() {

        return {
            patients: [],
            filter: {
                search: ``
            },
        };
    },

    mounted() {

        this.fetchInpatientQueue();
    },

    methods: {

        fetchInpatientQueue() {
            let url = `Pharmacy/GetInPatientPharmacyQueue`;
            url += this.filter.search ? `?SearchText=${this.filter.search}` : ``;
            this.$root.loading = true;
            return this.$http.get(url).then(response => {
                this.patients = response.data;
                this.$root.loading = false;
            }).catch(() => { this.$root.loading = false; });
        },
    },
}
</script>
<template>
    <tail-base-layout>
        <template v-slot:breadcrum></template>
        <template v-slot:content>
            <tail-card>
                  <template v-slot:card-header>
                      <h5 class="font-medium text-sm"> IP Drug Dispensing</h5>
                  </template>
                  <template v-slot:card-body>
                      <div class="flex flex-wrap">
                          <div class="md:w-1/3 w-full p-tiny">
                              <label for="grid-search" class="label-control">Search:</label>
                              <input type="text" 
                                @keydown.enter="fetchInpatientQueue" 
                                v-model.trim="filter.search" 
                                id="grid-search" class="input-control input-sm text-xs">
                          </div>
                          <div class="md:w-1/3 w-full p-tiny mt-4">
                            <button class="btn-sm btn-info text-xs" 
                                @click.prevent="fetchInpatientQueue">
                                <i class="fa fa-filter"></i> Filter</button>
                          </div>
                      </div>
                      <div class="w-full overflow-auto">
                          <table class="table table-hover">
                              <thead class="bg-blue-500 text-sm text-white">
                                  <tr class="w-full flex">
                                      <th class="p-tiny w-1/6">Patient</th>
                                      <th class="p-tiny flex-1">IP NO</th>
                                      <th class="p-tiny flex-1">National ID</th>
                                      <th class="p-tiny flex-1">Admitted On</th>
                                      <th class="p-tiny flex-1">Days</th>
                                      <th class="p-tiny w-1/6">P Mode</th>
                                      <th class="p-tiny flex-1">Action</th>
                                  </tr>
                              </thead>
                              <tbody class="text-xs bg-gray-100 flex flex-col items-center overflow-auto" style="height: 67vh;">
                                  <tr class="w-full flex" v-for="(patient,idx) in patients" :key="idx">
                                      <td class="p-tiny w-1/6">
                                          <h5 class="text-sm text-gray-900">{{ patient.names }}</h5>
                                          <h5 class="text-xs leading-5 text-gray-700">
                                              MRN: {{ patient.patienT_ID }}</h5>
                                          <h5 class="text-xs leading-5 text-gray-700">
                                              DOB: {{ patient.dob | dateFormat }}</h5>
                                      </td>
                                      <td class="p-tiny flex-1">{{ patient.ipfileno }}</td>
                                      <td class="p-tiny flex-1">{{ patient.nationalid }}</td>
                                      <td class="p-tiny flex-1">{{ patient.dateAdmitted | dateFormat }}</td>
                                      <td class="p-tiny flex-1">{{ patient.days }}</td>
                                      <td class="p-tiny w-1/6">{{ patient.pmode }}</td>
                                      <td class="p-tiny flex-1">
                                          <router-link 
                                            class="btn-sm text-xs btn-primary rounded" 
                                            :to="{ 
                                                    name: `pharmacy.dispense.create`, 
                                                    params: { 
                                                        patientID: patient.patienT_ID, 
                                                        visitNO: patient.visitNo, 
                                                    }
                                                }">
                                                 <i class="fa fa-pills"></i>
                                        </router-link>
                                      </td>
                                  </tr>
                              </tbody>
                          </table>
                      </div>
                  </template>
            </tail-card>
        </template>
    </tail-base-layout>
</template>